import React from "react";

import { Field, FieldLabel } from "../../../../components/FormPanel";
import { FormInput } from "../../../../components/Input";
import { NAME_RULES } from "./constants";
import { EditorFieldsProps } from "./types";

export const NameField: React.FC<EditorFieldsProps> = ({
  control,
  disabled,
}) => (
  <Field>
    <FieldLabel htmlFor="instrument-editor-name">Name (optional)</FieldLabel>
    <FormInput
      id="instrument-editor-name"
      name="name"
      control={control}
      rules={NAME_RULES}
      disabled={disabled}
    />
  </Field>
);
